/**
 * Constante que contiene un objeto con los textos de la página
 */
 export const objText = {
    titulos: {
        loginAdministrador: 'Acceso a Módulo de Administración',
        datosAcceso: 'Datos de Acceso',
    },
    parrafo: 'Es necesario validar que su usuario dispone de los permisos adecuados para acceder a este módulo.',
    alert: {
        title: 'Hubo un problema',
    },
    textoRequired: '*',
    helperText: {
        username: 'Debe seguir el formato de NIF (8 números + letra) o NIE (letra + 7 números + letra)',
        password: 'Debe informar este campo',
    },
    botones: {
        btnCancelar: 'CANCELAR',
        btnLogin: 'ACCEDER',
    },
};

//////////////////////////////////////////////////////
/**
 * @constant attributesIdName contiene los atributos id y name
 * @param {*} text se inserta el texto para los atributos
 * Se crea para aprovechar que el atributo id y el name reciben el mismo nombre
 */
const attributesIdName = (text) => ({
    id: text,
    name: text,
});
/**
 * @constant attributesValidation contiene las propiedades error y helperText.
 * Si la condición proporcionada por el parámetro value es false, se insertarán
 * los vamores de estas propiedades.
 * Con esta constante aplicamos si un campo no es válido.
 * @param {*} value recibe un valor boolean
 * @param {*} hlpTxt recibe el texto de la propiedad
 */
export const attributesValidation = (value, hlpTxt) => (
    !value && {
        error: true,
        helperText: hlpTxt,
    }
)
export const attributesValidationForm = (value, form)=> (
    !value && {
        error: true,
        FormHelperText: form,
    }
)

/**
 * Se crea la constante para insertar los atributos de los inputs
 * @constant attributesInputs contiene los atributos para los componentes inputs
 * @param {*} text recibe el texto a insertar a los atributos grid, id, name y htmlFor
 * @param {*} titlTextField recibe el título del inputLabel
 * @param {*} placeholder recibe el texto del placeholder
 */
const attributesInputs = (text, maxLength, title, txtRequired, required, placeholderTxt) => ({
    idGrid: 'grid' + text,
    ...attributesIdName(text),
    htmlFor: text,
    titlTextField: title,
    textRequired: txtRequired,
    isRequired: required,
    placeholder: placeholderTxt,
    type: 'text',
    maxlength: maxLength,
});

/**
 * @constant objAttributes contiene un objeto con todos los atributos según etiqueta o componente,
 */
export const objAttributes = {
    //Containers
    containers: {
        //Container formularioAltaUsuario (Contenedor padre)
        formularioLoginAdministrador: {
            id: 'containerFormLoginAdministrador',
            component: 'div',
        }, componentes: {
            id: 'containerComponentes',
            component: 'div',
        },
    },
    grids: {
        encabezado: {
            id: 'gridEncabezado',
        },
        datosAcceso: {
            id: 'gridDatosAcceso',
        },
        botones: {
            id: 'gridBotones',
        },
    },

    //Títulos de encabezado
    titulos: {
        //Título de la página
        loginAdministrador: {
            ...attributesIdName('loginAdministrador'),
        },
        //Título datos personales
        datosAcceso: {
            ...attributesIdName('datosAcceso'),
        },
    },
    //Parrafo de encabezado
    parrafo: {
        ...attributesIdName('txtLoginAdministrador'),
    },
    //Alert
    alert: {
        severity: 'error',
        color: 'error',
        variant: 'outlined',
        icon: false,
    },
    //Formulario
    form: {
        ...attributesIdName('formLoginAdministrador'),
    },
    //Inputs text, maxLength, title, txtRequired, required, placeholderTxt
    inputs: {       
        username: {
            ...attributesInputs('username', '15', 'Usuario', objText.textoRequired, true,  'Usuario'),
            disabled: false,
        },
        password: {
            ...attributesInputs('password', '100', 'Contraseña', objText.textoRequired, true, 'Contraseña'),
            disabled: false,
        },        
    },    
    //Botones
    btnLogin: {
        ...attributesIdName('botonLogin'),
        type: 'submit',
    },
    btnCancelar: {
        ...attributesIdName('botonCancelar'),
        type: 'submit',
    },
}